import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { CommonCollections } from '../../App';
import { filteringTableGetButtonIcon } from '../../utils/filteringTableGetButtonIcon';
import { filteringTableGetButtonToolTipText } from '../../utils/filteringTableGetButtonToolTipText';
import { useAdminActionCollections } from '../../context/AdminActionCollections';
import { NOMINATION_STATUS } from '../../utils/constants';

const NominationCell = ({ row }) => {
  const { setNominationId } = useContext(CommonCollections);
  const { nominationStatusTypeId, nominationId } = row.original;
  const { enableSubmissionEdit } = useAdminActionCollections();

  const buttonIcon = filteringTableGetButtonIcon(nominationStatusTypeId);
  const buttonToolTipText = filteringTableGetButtonToolTipText(
    nominationStatusTypeId,
  );

  if (
    !enableSubmissionEdit &&
    nominationStatusTypeId === NOMINATION_STATUS.DRAFT
  ) {
    return '';
  }

  return (
    <Link
      to={
        nominationStatusTypeId === NOMINATION_STATUS.DRAFT
          ? '/application'
          : '/form-view'
      }
      onClick={() => {
        setNominationId(nominationId);
      }}
    >
      <span title={buttonToolTipText}>
        <i className={buttonIcon} />
      </span>
    </Link>
  );
};

NominationCell.propTypes = {
  row: PropTypes.object.isRequired,
};

export default NominationCell;
